import React from 'react';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import AboutUsSection from './AboutUsSection';
import WhatWeDoSection from './WhatWeDoSection';
import AchievementSection from './AchievementSection';
import Footer from './Footer';
import { siteConfig } from '../config/siteConfig';
import './WhyNexusLiving.css';

const WhyNexusLiving = ({ config = siteConfig }) => {
  return (
    <div className="why-nexus-living">
      <Navigation config={config.navigation} alwaysScrolled={true} />
      <HeroSection config={config.whyNexusHero} className="why-nexus" />
      <div className="about-what-container">
        <div className="about-what-content">
          <div className="about-what-left">
            <div className="about-what-image">
              <img 
                src={config.aboutUs.image} 
                alt="Construction workers reviewing blueprints" 
                className="about-what-img"
              />
            </div>
          </div>
          <div className="about-what-right">
            <AboutUsSection config={config.aboutUs} />
            <WhatWeDoSection config={config.whatWeDo} />
          </div>
        </div>
      </div>
      <AchievementSection config={config.achievement} />
      <Footer config={config.footer} />
    </div>
  );
};

export default WhyNexusLiving;
